// userrole view page with create newrole button

import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, ThemeProvider } from '@mui/material';

import getTheme from '../../theme/theme';
import { useNavigate } from 'react-router-dom';
import BasicTable, { Column } from '../../components/table';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { BASEURL, ARROW } from '../../constants/Common';
import FloatingButton from '../usersupport/helpdesk/FloatingButton';
export interface SubscriptionPlan {
  title: string;
  price: number;
  projects: number;
  users: number;
  // Add other properties if available
}
export interface Organization {
  subscription_start_date: string;
  subscription_end_date: string;
  active_users_count: number;
  active_project_count: number;
  organization_subscription_status: string;
  subscription_id: number;
  organization_name: string;
}
export interface OrganizationFinal {
  organization: Organization;
  subscription_plan: SubscriptionPlan;
}

export interface UserRole {
  id: number | null;
  rolename: string;
  status: string; // Allow any string value for status
  projectaccess: string; // Allow any string value for projectaccess
  scheduleaccess: string; // Allow any string value for scheduleaccess
  modulesaccess: string; // Allow any string value for modulesaccess
  reportsaccess: string; // Allow any string value for reportsaccess
  note: string;
  createdon: string | Date | null; // Update the type to accept string or Date
  [key: string]: string | number | null | Date | string;
}

const UserRolePage: React.FC = () => {
  const [organizationfinal, setOrganizationFinal] =
    useState<OrganizationFinal | null>(null);
  const [loading, setLoading] = useState(true);
  const storedAdmindata = localStorage.getItem('userRoleAdmin');
  let UserroleAdmin: any = null;

  if (storedAdmindata) {
    UserroleAdmin = JSON.parse(storedAdmindata);
  } else {
    console.log('No data found in localStorage');
  }
  const [userRole, setUserRole] = useState<string>(UserroleAdmin);
  const theme = getTheme();

  const navigate = useNavigate();

  const handleCreateNew = () => {
    navigate('/adduserrole',{ state: { filteredRows } });
  };

  const storedData = localStorage.getItem('orgid');
  let parsedData: any = null; // Define parsedData variable with 'any' type

  if (storedData) {
    parsedData = JSON.parse(storedData);
  } else {
   navigate('/login')
  }
  const organizationid = parsedData;

  const [userroles, setUserRoles] = useState<UserRole[]>([]);


  // API call to fetch all the created user role list
  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const response = await axios.get(BASEURL + '/userrole/', {
          headers: {
            Accept: 'application/json',
          },
        });
       
        setUserRoles(response.data.user_roles);
      } catch (error) {
        console.log(error);
      }
    };
    fetchUserRoles();
  }, []);

  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        const response = await axios.get(
          BASEURL + '/organization' + `/${organizationid}/`,
          {
            headers: {
              Accept: 'application/json',
            },
          }
        );
        // setOrganization(response.data);
        setOrganizationFinal(response.data);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };
    fetchOrganization();
  }, []);


  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const roleId = queryParams.get('role_id');
  const [roleDetails, setRoleDetails] = useState<UserRole | null>(null);

  //API for view row list

  useEffect(() => {
    const fetchRoleDetails = async () => {
      try {
        if (roleId) {
          const response = await axios.get(BASEURL + `/userrole/${roleId}/`);
          setRoleDetails(response.data);
          // console.log('row response data:', response.data);
        }
      } catch (error) {
        console.error('Error fetching role details:', error);
      }
    };

    fetchRoleDetails();
  }, [roleId]);

  const currentDate = new Date();
const subscriptionEndDate = organizationfinal?.organization?.subscription_end_date;

let expiredate;
if (subscriptionEndDate) {
  const enddate = new Date(subscriptionEndDate);
  expiredate = currentDate < enddate ? "Active" : "Expired";
} else {
  expiredate = "Expired"; // or any default status you prefer
}

console.log(expiredate); 
  const handleViewRole = (role: UserRole) => {
    const roleId = role.id; // Assuming the ID is stored in a property named 'id' in the UserRole object
    navigate(`/view-role?role_id=${roleId}`);
  };

  const isSubscriptionExpired = (status: string | undefined): boolean => {
    return status === 'Expired';
  };


  const columns: Column[] = [
    { id: 'rolename', label: 'Role Name', align: 'left' },
    { id: 'status', label: 'Status', align: 'right' },
    { id: 'createdon', label: 'Created Date', align: 'right' },
    { id: 'action', label: '', align: 'right' },
  ];

  const filteredRows = userroles.filter(
    (role) => role.organization_id === organizationid
  );


  const isUserAdmin = userRole === 'Admin';
  
  const rows = filteredRows.map((log, index) => ({
    id: index + 1,
    rolename: log.rolename,
    status: log.status,
    createdon: log.createdon,
    action: (
      <Button
        key={log.id}
        variant='contained'
        onClick={() => handleViewRole(log)}
        disabled={
          (!isUserAdmin && log.rolename !== userRole) ||
          isSubscriptionExpired(organizationfinal?.organization?.organization_subscription_status)
        }
        sx={{
          textTransform: 'uppercase',
          color: theme.palette.common.black,
          '&:disabled': {
            // Adding styles for disabled state
            color: theme.palette.grey[500],
          },
        }}
      >
        View
      </Button>
    ),
  }));

  return (
    <ThemeProvider theme={getTheme()}>
      <Box sx={{ marginTop: '-60px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ flex: 'auto' }}>
            <Typography variant='h6' component='div'>
              <Link to={'/useraccount'}>User Account</Link>
              {ARROW} User Roles
            </Typography>
          </Box>
          <Box sx={{ marginLeft: 'auto' }}>
            <Button
              variant='contained'
              onClick={handleCreateNew}
              // disabled={!isUserAdmin}
              disabled={
                !isUserAdmin ||
                !(
                  organizationfinal?.organization
                    ?.organization_subscription_status === 'Active' &&
                  organizationfinal?.organization?.active_users_count <
                    organizationfinal?.subscription_plan?.users
                ) ||
                organizationfinal?.organization?.active_users_count ===
                  organizationfinal?.subscription_plan?.users ||
                isSubscriptionExpired(
                  organizationfinal?.organization
                    ?.organization_subscription_status
                ) ||
                !organizationfinal?.organization
                  ?.organization_subscription_status
              }
              sx={{
                textTransform: 'uppercase',
                color: theme.palette.common.black,
                '&:disabled': {
                  // Adding styles for disabled state
                  color: theme.palette.grey[500],
                },
              }}
            >
              Create New
            </Button>
          </Box>
        </Box>
        {loading ? (
              <Typography variant='body1'></Typography>
            ) : isSubscriptionExpired(
          organizationfinal?.organization?.organization_subscription_status
        ) && (
          <Typography variant='h6'>
            Your subscription plan is expired. Please renew your subscription
            plan.
          </Typography>
        )}
        {loading ? (
              <Typography variant='body1'></Typography>
            ) : organizationfinal?.organization?.active_users_count ===
          organizationfinal?.subscription_plan?.users && (
          <Typography variant='h6'>
            Please upgrade your subscription plan to add more users.
          </Typography>
        )}
        { loading ? (
              <Typography variant='body1'></Typography>
            ) : !organizationfinal?.organization?.organization_subscription_status && (
          <Typography variant='h6' >
            Please purchase a subscription plan.
          </Typography>
        )}
        <Box sx={{ marginTop: '80px' }}>
          <BasicTable columns={columns} rows={rows} />
        </Box>
        <FloatingButton/>
      </Box>
    </ThemeProvider>
  );
};

export default UserRolePage;
